var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 40,
    viewBox: "0 0 48 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    rx: 8,
    fill: "#F6F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 25.4999H19C18.8674 25.4999 18.7402 25.4473 18.6464 25.3535C18.5527 25.2597 18.5 25.1326 18.5 24.9999V22.2062C18.4998 22.1413 18.5124 22.0769 18.537 22.0169C18.5617 21.9568 18.598 21.9022 18.6438 21.8562L26.1438 14.3562C26.1903 14.309 26.2457 14.2714 26.3069 14.2458C26.3681 14.2202 26.4337 14.207 26.5 14.207C26.5663 14.207 26.632 14.2202 26.6931 14.2458C26.7543 14.2714 26.8097 14.309 26.8563 14.3562L29.6438 17.1437C29.691 17.1902 29.7285 17.2457 29.7541 17.3068C29.7797 17.368 29.7929 17.4336 29.7929 17.4999C29.7929 17.5663 29.7797 17.6319 29.7541 17.6931C29.7285 17.7542 29.691 17.8097 29.6438 17.8562L22 25.4999Z",
    stroke: "#050F4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 25.5H22",
    stroke: "#050F4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 16L28 19.5",
    stroke: "#050F4E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.0615eef301df0859fa03a8b306bd524c.svg";
export { ForwardRef as ReactComponent };